// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"26ba00b0","109":"e067a846","180":"78b5be53","312":"c41ff520","416":"601f600f","529":"f791c8b1","560":"b5a36e0e","594":"e5bce72e","600":"dbcc0f35","745":"aee8d24a"}[chunkId] + ".chunk.js";
};